import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectBuyPackageModalData,
  selectIsBuyPackageModalAutoprolongAvailable,
} from '../../../../selectors/buyPackageModal';
import { Autoprolong } from './Autoprolong';
import { setBuyPackageModalAutoProlong } from '../../../../slices';

/**
 * NOTE: Это копия BuyConfirmationModal/components/Autoprolong/AutoprolongContainer.tsx
 * Нужен рефакторинг этих двух модалок, чтобы точкой входа был BuyConfirmationModalContainer,
 * 2 отдельных компонента для mobile и desktop, которые собирают представление из нужных компонентов, а
 * компоненты подстраивались под устройство сами.
 */
export const AutoprolongContainer = () => {
  const { autoProlong } = useSelector(selectBuyPackageModalData);
  const isAvailable = useSelector(selectIsBuyPackageModalAutoprolongAvailable);

  const dispatch = useDispatch();

  const handleChange = React.useCallback(
    (_: React.ChangeEvent, autoProlong: boolean) => {
      dispatch(setBuyPackageModalAutoProlong(autoProlong));
    },
    [dispatch],
  );

  if (!isAvailable) {
    return null;
  }

  return <Autoprolong checked={autoProlong} onChange={handleChange} />;
};
